import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Row, Col, Button, Container } from "react-bootstrap";
import classes from "../WebsiteManagement/websiteManagement.module.css";
import Page from "../pagination/pagination";
import {
  GetServiceManagementFlightBookings,
  DownloadBookingTicket,
  DownloadBookingInvoice,
} from "../../entities/action/action";

const PAGE_SIZE = 50;
const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const FlightBookingCard = ({ item }) => {
  const travelDate = new Date(item?.flightDate);
  const orderDate = new Date(item?.orderDate);

  return (
    <Row
      style={{
        backgroundColor: "#f9f9f9",
        padding: "15px 25px",
        alignItems: "center",
        boxShadow: "-1px 2px 8px #ddd",
        margin: "15px 0",
      }}
    >
      <Col md={2}>
        <div style={{ color: "#adb0b8" }}>{travelDate.getDate()}</div>
        <div>{month[travelDate.getMonth()]}</div>
        <div style={{ color: "#ef3f3e" }}>{travelDate.getUTCFullYear()}</div>
      </Col>
      <Col md={2}>✈️</Col>
      <Col md={3}>
        <div>
          {item?.segments?.reduce((prev, curr, index) => {
            let val = prev + `${curr.origin} to ${curr.destination}`;
            if (index < item.segments.length - 1) val += ", ";
            return val;
          }, "")}
        </div>
        <div style={{ color: "gray" }}>{item?.name}</div>
        <div style={{ color: "gray" }}>{item?.phone}</div>
        <div style={{ color: "gray" }}>INR {Number(item?.amount) / 100}</div>
      </Col>
      <Col md={3}>
        <p>ID: {item?.orderId}</p>
        <div style={{ color: "gray" }}>
          {orderDate.getDate()}/{month[orderDate.getMonth()]}/{orderDate.getUTCFullYear()}
        </div>
      </Col>
      <Col md={2}>
        <Button size="sm" variant="outline-primary" style={{ fontSize: 10, marginBottom: 5 }} onClick={() => DownloadBookingTicket(item.bookingId)}>
          Download Ticket
        </Button>
        <Button size="sm" variant="outline-secondary" style={{ fontSize: 10 }} onClick={() => DownloadBookingInvoice(item.bookingId)}>
          Download Invoice
        </Button>
        <div style={{ background: "#0dcaf0", padding: 5, marginTop: 5, textAlign: "center" }}>
          {(item?.status || "").toUpperCase()}
        </div>
      </Col>
    </Row>
  );
};

const FlightBookings = () => {
  const [all, setAll] = useState([]);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    (async () => {
      const res = await GetServiceManagementFlightBookings();
      if (res.success && res.bookings) setAll(res.bookings);
    })();
  }, []);

  useEffect(() => {
    setPage(1);
  }, [search]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return all;
    return all.filter(
      (b) =>
        (b.name || "").toLowerCase().includes(q) ||
        String(b.phone || "").toLowerCase().includes(q)
    );
  }, [all, search]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const pageItems = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <Fragment>
      <Container style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
        <form
          onSubmit={(e) => e.preventDefault()}
          style={{ display: "flex", alignItems: "stretch", width: "50vw" }}
        >
          <input
            className={classes.SearchInput}
            placeholder="Search by Name or Phone Number"
            value={searchInput}
            onChange={(e) => {
              setSearchInput(e.target.value);
              setSearch(e.target.value);
            }}
          />
          <button type="button" className={classes.SearchButton} onClick={() => setSearch(searchInput)}>
            Search
          </button>
        </form>
      </Container>
      {pageItems.length ? pageItems.map((item) => <FlightBookingCard key={item.bookingId} item={item} />) : <p>No flights found</p>}
      {totalPages > 1 && <Page count={totalPages} page={page} change={(_, v) => setPage(v)} />}
    </Fragment>
  );
};

export default FlightBookings;
